module.exports = __webpack_public_path__ + "static/media/MuseoSansRegular.ef3daa6f.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/MuseoSansRegular/MuseoSansRegular.ttf
// module id = 637
// module chunks = 0